import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.png";
import "./Sidebar.css";
import { Icon } from "react-icons-kit";
import { arrow_down } from "react-icons-kit/ikons/arrow_down";
import { tv } from "react-icons-kit/feather/tv";
import { useNavigate, useLocation } from "react-router-dom";
import { useJwt } from "react-jwt";
import { DeleteEmployee, GetEmployePage } from "../apiconfig/authService";
import { Pagination } from "rsuite";
import { FaUser } from "react-icons/fa";
import { AiFillProduct } from "react-icons/ai";
import { CiShoppingCart } from "react-icons/ci";
import { MdCategory } from "react-icons/md";
import { TbCategoryPlus } from "react-icons/tb";
import { TfiLayoutMediaOverlayAlt } from "react-icons/tfi";
import { TfiLayoutSlider } from "react-icons/tfi";
import { MdFeedback } from "react-icons/md";
import { FaStore } from "react-icons/fa6";
import { FaUserTie } from "react-icons/fa6";
import { FaCircleUser } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";
import { TbBrandDatabricks } from "react-icons/tb";
import { FaShop } from "react-icons/fa6";
// import { IoLogOut } from "react-icons/io5";
import { MdShoppingCart } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import { GrGallery } from "react-icons/gr";
import { FaCircleInfo } from "react-icons/fa6";
// import { MdDetails } from "react-icons/md";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { TbListDetails } from "react-icons/tb";
import { IoLogoGooglePlaystore } from "react-icons/io5";
const Sidebar = () => {
  const location = useLocation();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [employeesData, setEmployeesData] = useState([]);
  const [searchedEmployeesData, setSearchedEmployeesData] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [recordIdToDelete, setRecordIdToDelete] = useState("");

  const [isUserOpen, setIsUserOpen] = useState(false);
  const toggleUserDropdown = () => setIsUserOpen(!isUserOpen);
  // Auto-open the dropdown on specific routes
  useEffect(() => {
    if (location.pathname.includes("/employee") || location.pathname.includes("/customer")) {
      setIsUserOpen(true);
    }
  }, [location.pathname]);


  const [isCatOpen, setIsCatOpen] = useState(false);
  const toggleCatDropdown = () => setIsCatOpen(!isCatOpen);
  // when we go other page dropdown not closed
  useEffect(() => {
    if (location.pathname.includes("/category") || location.pathname.includes("/subcategory")) {
      setIsCatOpen(true);
    }
  }, [location.pathname]);





  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const toggleMediaDropdown = () => setIsMediaOpen(!isMediaOpen);
  useEffect(() => {
    if (location.pathname.includes("/media") || location.pathname.includes("/slider")) {
      setIsMediaOpen(true);
    }
  }, [location.pathname]);






  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const toggleFeedbackDropdown = () => setIsFeedbackOpen(!isFeedbackOpen);

  useEffect(() => {
    if (location.pathname.includes("/feedback") || location.pathname.includes("/stores")) {
      setIsFeedbackOpen(true);
    }
  }, [location.pathname]);


  const [islayoutOpen, setIslayoutOpen] = useState(false);
  const toggleLayoutOpenDropdown = () => setIslayoutOpen(!islayoutOpen);

  useEffect(() => {
    if (
      location.pathname.includes("/wedget") ||
      location.pathname.includes("/banner") ||
      location.pathname.includes("/brand")
    ) {
      setIslayoutOpen(true);
    }
  }, [location.pathname]);




  const [isOrderProductOpen, setIsOrderProductOpen] = useState(false);
  const toggleOrderProductDropdown = () => setIsOrderProductOpen(!isOrderProductOpen);

  useEffect(() => {
    if (location.pathname.includes("/order") || location.pathname.includes("/product")) {
      setIsOrderProductOpen(true);
    }
  }, [location.pathname]);





  const navigate = useNavigate();
  const { decodedToken } = useJwt(localStorage.getItem("accessToken"));

  const handleSignoutClick = async () => {
    localStorage.removeItem("accessToken");
    navigate("/");
  };

  useEffect(() => {
    setSearchedEmployeesData(
      employeesData.filter(
        (item) =>
          item.firstname?.includes(search) ||
          item.lastname?.includes(search) ||
          item.emailid?.includes(search)
      )
    );
  }, [search, employeesData]);

  useEffect(() => {
    (async () => {
      try {
        const response = await GetEmployePage(
          page,
          itemsPerPage,
          localStorage.getItem("accessToken")
        );
        setEmployeesData([...response.data.items]);
        // console.log("employeesData>>>>>>", ...response.data.items);
        setSearchedEmployeesData([...response.data.items]);
        setTotalEmployees(response.data.pagination.count);
        setPageCount(Math.ceil(response.data.pagination.pageCount));
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, itemsPerPage]);

  const handleViewCategoryClick = (emailid) => {
    navigate(`/myprofle/${emailid}`);
  };

  // const [emails, setEmails] = useState('');
  //   if (searchedEmployeesData.length > 0) {
  //     setEmails(searchedEmployeesData[0].emailid);
  //     console.log("First employee email:",searchedEmployeesData[0].emailid);
  //   }

  const firstEmail =
    searchedEmployeesData.length > 0 ? searchedEmployeesData[0].emailid : null;
  console.log("firstEmail", firstEmail);



  const [activeItem, setActiveItem] = useState('');

  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (
      location.pathname.includes("/blinkit") ||
      location.pathname.includes("/zepto") ||
      location.pathname.includes("/dmart") ||
      location.pathname.includes("/swiggy") ||
      location.pathname.includes("/bigBasket") ||
      location.pathname.includes("/jiomart") ||
      location.pathname.includes("/flipkart") ||
      location.pathname.includes("/amazon") ||
      location.pathname.includes("/flipkartmintues")

    ) {
      setIsExpanded(true);
    }
  }, [location.pathname]);


  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);




  return (
    <div>

      <div className="nav-only-phone d-md-none">
        <div className="img-pi-logo">
          <img src="/static/media/logo.1c08c1e01e0bf9677c66.png" alt="" />
        </div>
        <button className="btn btn-primary d-md-none" onClick={toggleSidebar}>
          ☰
        </button>

      </div>






      <div
        className="modal fade"
        id="signoutModal"
        tabIndex="10"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body text-center p-5">
              <h1 className="modal-title display-6 mb-4" id="exampleModalLabel">
                Procced with Signout?
              </h1>
              <button
                type="button"
                className="btn btn-danger me-2"
                data-bs-dismiss="modal"
              >
                No
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSignoutClick();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`sidebar offcanvas offcanvas-start ${isSidebarOpen ? 'show' : ''}`}
        data-bs-scroll="true"
        data-bs-backdrop="false"
        tabIndex="-1"
        id="offcanvasScrolling"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div className="profile offcanvas-header p-2 flex-wrap bg-light">
          <button
            className="btn btn-toggle collapsed userProfile d-flex align-items-center w-100 position-relative"
            data-bs-toggle="collapse"
            data-bs-target="#profile-collapse"
            aria-expanded="false"
          >
            <span className="userPic">
              <img className="img-fluid" src={logoImg} width="50" alt="" />
              {/*<span className="userLetter">V</span>*/}
            </span>
            <span className="nameTag">
              <span className="offcanvas-title h5" id="offcanvasScrolling">
                {decodedToken?.name}
              </span>
              <span className="clearfix"></span>
              {/* <span className="mb-0 w-100"><small className="text-muted">User Designation</small></span> */}
              <Icon
                className="arrow_down"
                icon={arrow_down}
                size={20}
                style={{ marginTop: "10px" }}
              />
            </span>
          </button>
          <div className="collapse dropdownList" id="profile-collapse">
            <ul className="btn-toggle-nav list-unstyled">
              <li className="active">
                {/* <NavLink
                  // to="/MyProfile"
                  onClick={() => {
                    handleViewCategoryClick(firstEmail);
                  }}
                  className="nav-link"
                >
                  My Profile
                </NavLink> */}
                <button
                  // style={{ marginLeft: "90px" }}
                  type="button"
                  className="profilebutton"
                  onClick={() => {
                    handleViewCategoryClick(firstEmail);
                  }}
                // className="actBtn viewBtn"
                >
                  <FaCircleUser size={17} className="profile-icon" />
                  My Profile
                  {/* <span className="toolTip">My Profile</span> */}
                </button>
              </li>
              {/* <li><NavLink to="#" className="nav-link">View Site</NavLink></li> */}
              <li>
                {/* <NavLink
                  className="nav-link"
                  onClick={() => handleSignoutClick()}
                >
                  Sign Out
                </NavLink> */}

                <button
                  style={{
                    // marginLeft: "90px",
                    marginTop: "10px",
                    listStyle: "inside",
                  }}
                  type="button"
                  className="profilebutton"
                  onClick={() => handleSignoutClick()}
                // className="actBtn viewBtn"
                >
                  <FiLogOut size={17} className="profile-icon" />
                  Log Out
                  {/* <span className="toolTip">My Profile</span> */}
                </button>
              </li>
            </ul>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <ul className="offcanvas-body list-unstyled p-0 mb-0">

          <li className="dropdownList">
            <NavLink
              to="/dashboard"
              className="nav-link"
            // activeClassName="actives"
            >
              <MdDashboard size={17} className="icon" />
              {/* <Icon className="tv" icon={tv} size={17} /> */}
              Dashboard
            </NavLink>
          </li>

          {/* User Management Start */}

          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${isUserOpen ? "active" : ""}`}
              onClick={toggleUserDropdown}
            >
              <span className="d-flex align-items-center">
                <FaUserTie size={17} className="icon" />
                <span className="text-custom-13">User Management</span>
              </span>
              {isUserOpen ? <MdExpandLess size={17} /> : <MdExpandMore size={17} />}
            </button>

            {isUserOpen && (
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink to="/employee" className="nav-link" activeClassName="actives">
                    <FaUserTie size={17} className="icon" />
                    <span className="inside-list-tab">Employee</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink to="/customer" className="nav-link" activeClassName="actives">
                    <FaUser size={17} className="icon" />
                    <span className="inside-list-tab">Customer</span>
                  </NavLink>
                </li>
              </ul>
            )}
          </li>


          {/* User Management End */}


          {/* Product Management Start*/}

          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${isOrderProductOpen ? "active" : ""}`}
              onClick={toggleOrderProductDropdown}
            >
              <span className="d-flex align-items-center">
                <MdShoppingCart size={17} className="icon" />
                <span className="text-custom-13">Order Management</span>
              </span>
              {isOrderProductOpen ? <MdExpandLess size={17} /> : <MdExpandMore size={17} />}
            </button>

            {isOrderProductOpen && (
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink to="/order" className="nav-link" activeClassName="actives">
                    <MdShoppingCart size={17} className="icon" />
                    <span className="inside-list-tab">Order</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink to="/product" className="nav-link" activeClassName="active">
                    <AiFillProduct size={17} className="icon" />
                    <span className="inside-list-tab">Product</span>
                  </NavLink>
                </li>
              </ul>
            )}
          </li>



          {/* Product Management End*/}



          {/* Category Management  start*/}
          <li className="dropdownList">

            <button
              className={` btn btn-toggle  d-flex align-items-center justify-content-between w-95 ${isExpanded ? "active" : ""}`}
              onClick={toggleCatDropdown}

            >
              <span className="d-flex align-items-center">
                <MdCategory size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span">Category Management</span>
              </span>
              {isCatOpen ? <MdExpandLess size={17} /> : <MdExpandMore size={17} />}
            </button>




            {/* Nested Category and Subcategory */}
            {isCatOpen && (
              <div className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/category"
                    className="nav-link"
                    activeClassName="actives"
                  >
                    <MdCategory size={17} className="icon" />
                    <span className="inside-list-tab">Category</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/subcategory"
                    className="nav-link"
                    activeClassName="actives"
                  >
                    <TbCategoryPlus size={17} className="icon" />
                    <span className="inside-list-tab">Subcategory</span>
                  </NavLink>
                </li>
              </div>
            )}
          </li>


          {/* Category Management  end*/}




          {/* Media Management Start*/}

          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${isMediaOpen ? "active" : ""}`}
              onClick={toggleMediaDropdown}
            >
              <span className="d-flex align-items-center">
                <TfiLayoutMediaOverlayAlt size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span ">Media Management</span>
              </span>
              {isMediaOpen ? <MdExpandLess size={17} /> : <MdExpandMore size={17} />}
            </button>

            {isMediaOpen && (
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink to="/media" className="nav-link" activeClassName="actives">
                    <TfiLayoutMediaOverlayAlt size={17} className="icon" />
                    <span className="inside-list-tab">Media</span>
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink to="/slider" className="nav-link" activeClassName="actives">
                    <TfiLayoutSlider size={17} className="icon" />
                    <span className="inside-list-tab">Slider</span>
                  </NavLink>
                </li>
              </ul>
            )}
          </li>





          {/* {Media Management End} */}



          {/* FeedBack management Start */}

          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${isFeedbackOpen ? "active" : ""}`}
              onClick={toggleFeedbackDropdown}
            >
              <span className="d-flex align-items-center">
                <MdFeedback size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span ">Feedback Management</span>
              </span>
              {isFeedbackOpen ? <MdExpandLess size={17} /> : <MdExpandMore size={17} />}
            </button>

            {isFeedbackOpen && (
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/feedback"
                    className="nav-link"
                    activeClassName="actives"
                  >
                    {/* <Icon className="tv" icon={tv} size={17} /> */}
                    <MdFeedback size={17} className="icon" />
                    Feedback
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/stores"
                    className="nav-link"
                    activeClassName="actives"
                  >
                    {/* <Icon className="tv" icon={tv} size={17} /> */}
                    <FaShop size={17} className="icon" />
                    Stores
                  </NavLink>
                </li>
              </ul>
            )}
          </li>


          {/* FeedBack management End */}





          {/* layout management  Start */}

          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${islayoutOpen ? "active" : ""}`}
              onClick={toggleLayoutOpenDropdown}
            >
              <span className="d-flex align-items-center">
                <FaStore size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span ">Layout Management</span>
              </span>
              {islayoutOpen ? <MdExpandLess size={17} /> : <MdExpandMore size={17} />}
            </button>

            {islayoutOpen && (
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/wedget"
                    className="nav-link"
                    activeClassName="actives"
                  >
                    {/* <Icon className="tv" icon={tv} size={17} /> */}
                    <FaStore size={17} className="icon" />
                    Widget
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/banner"
                    className="nav-link"
                    activeClassName="actives"
                  >
                    <GrGallery size={17} className="icon" />
                    Banner
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink to="/brand" className="nav-link" activeClassName="actives">
                    <TbBrandDatabricks size={17} className="icon" />
                    Brand
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink to="/tags" className="nav-link" activeClassName="actives">
                    {/* <Icon className="tv" icon={tv} size={25} /> */}
                    <TbBrandDatabricks size={25} className="icon" />
                    Tags
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink to="/notification" className="nav-link" activeClassName="actives">
                    {/* <Icon className="tv" icon={tv} size={25} /> */}
                    <TbBrandDatabricks size={25} className="icon" />
                    Notification
                  </NavLink>
                </li>
              </ul>
            )}
          </li>


          {/* layout management End */}

          {/* Details Management start*/}
          <li className="dropdownList">
            <button
              className={`btn btn-toggle d-flex align-items-center justify-content-between w-95 ${isExpanded ? "active" : ""}`}
              onClick={handleToggle}
            >
              <span className="d-flex align-items-center">
                <TbListDetails size={17} className="icon" />
                <span className="text-custom-13 cataegory-management-span ">Store Management</span>
              </span>
              {isExpanded ? <MdExpandLess size={17} /> : <MdExpandMore size={17} />}
            </button>


            {isExpanded && (
              <ul className="list-unstyled ps-4">
                <li className="dropdownList">
                  <NavLink
                    to="/blinkit"
                    className={`nav-link my-2 ${activeItem === 'blinkit' ? 'active' : ''}`}
                    onClick={() => setActiveItem('blinkit')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    Blinkit
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/zepto"
                    className={`nav-link my-2 ${activeItem === 'zepto' ? 'active' : ''}`}
                    onClick={() => setActiveItem('zepto')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    Zepto
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/dmart"
                    className={`nav-link my-2 ${activeItem === 'dmart' ? 'active' : ''}`}
                    onClick={() => setActiveItem('dmart')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    Dmart
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/swiggy"
                    className={`nav-link my-2 ${activeItem === 'swiggy' ? 'active' : ''}`}
                    onClick={() => setActiveItem('swiggy')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    Swiggy
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/bigBasket"
                    className={`nav-link my-2 ${activeItem === 'bigbasket' ? 'active' : ''}`}
                    onClick={() => setActiveItem('bigbasket')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    BigBasket
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/jiomart"
                    className={`nav-link my-2 ${activeItem === 'jiomart' ? 'active' : ''}`}
                    onClick={() => setActiveItem('jiomart')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    Jiomart
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/flipkart"
                    className={`nav-link my-2 ${activeItem === 'flipkart' ? 'active' : ''}`}
                    onClick={() => setActiveItem('flipkart')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    Flipkart
                  </NavLink>
                </li>
                <li className="dropdownList">
                  <NavLink
                    to="/amazon"
                    className={`nav-link my-2 ${activeItem === 'amazon' ? 'active' : ''}`}
                    onClick={() => setActiveItem('amazon')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    Amazon
                  </NavLink>
                </li>

                <li className="dropdownList">
                  <NavLink
                    to="/flipkartMintues"
                    className={`nav-link my-2 ${activeItem === 'flipkartmintues' ? 'active' : ''}`}
                    onClick={() => setActiveItem('flipkartmintues')}
                  >
                    <IoLogoGooglePlaystore size={17} className="icon" />
                    Flipkart Mintues
                  </NavLink>
                </li>
              </ul>
            )}
          </li>
          {/* Details Management end*/}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;